import axios from "axios";

const AI_API_URL  = process.env.REACT_APP_PUBLIC_AI_API_URL;




export async function faqRag(question, k = 10) {
  const q = (question || "").trim();
  if (!q) throw new Error("Question cannot be empty.");

  try {
    const res = await axios.post(
      `${AI_API_URL}/faq/chat`,
      { question: q, k },
      { headers: { "Content-Type": "application/json" } }
    );

    return res.data;
  } catch (error) {
    if (error && error.response) {
      const resp = error.response;
      const serverMsg =
        resp.data?.detail ||
        resp.data?.message ||
        (typeof resp.data === "string" ? resp.data : JSON.stringify(resp.data));
      throw new Error(serverMsg || `Request failed with status ${resp.status}`);
    }
    throw new Error(error?.message || "An unexpected error occurred");
  }
}


export async function agriChat(
  question
){
  try {
    const response = await axios.post(
      `${AI_API_URL}/chat/agrichat`, 
      {question: question},
      {headers: { "Content-Type": "application/json",}},

    );

    // if (!response.ok) {
    //   const error = await response.data;
    //   throw new Error(error.detail || "Failed to get response from AgriChat");
    // }

    const data = await response.data;
    return data;
  } catch (error) {
    if (error && error.response) {
      const resp = error.response;
      const serverMsg =
        resp.data?.detail ||
        resp.data?.message ||
        (typeof resp.data === "string" ? resp.data : JSON.stringify(resp.data));
      throw new Error(serverMsg || `Request failed with status ${resp.status}`);
    }
    throw new Error(error?.message || "An unexpected error occurred");
  }
}
